import styled from 'styled-components'

const DEFAULT_COLORS = {
  warning: { color: 'var(--golden-yellow)', background: 'var(--clean-gray)' },
  error: { color: 'var(--bronze-gold)', background: 'var(--light-pink)' },
  info: { color: 'var(--pet-anjo-dark-blue)', background: 'var(--pet-anjo-light-blue)' },
  success: { color: 'var(--success)', background: 'var(--success-pastel)' },
  outline: { color: 'var(--cobasi-blue-light-8)', background: 'transparent', border: '1px solid var(--cobasi-blue-light-8)' },
  default: { color: 'var(--cobasi-blue-light-8)', background: 'var(--pet-anjo-lighter-blue)' },
  featured: { color: 'var(--coral-orange)', background: 'var(--coral-orange-light)' }
}

export const Container = styled.div`
  display: flex;
  min-height: 23px;
  padding: 2px 8px;
  width: fit-content;
  align-items: center;
  gap: 5px;
  border-radius: 8px;
  font-family: var(--primary-font);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  ${({ type }) => type ? DEFAULT_COLORS[type] : DEFAULT_COLORS.default}
`
